import { buildPrompt } from '@/ai/utils/promptBuilder'
import { examples } from '@/ai/prompts/common/examples'
import { readModelNotes } from '@/ai/prompts/common/instructions'
import { systemMessages } from '@/ai/prompts/common/systemMessages'
import { getJsonOutputFormatting } from '@/ai/prompts/common/formatting'
import {
  createSystemMessage,
  createUserMessage,
  diagramToJson,
  getWorkflowBackgroundSections
} from '@/ai/utils/promptUtils'

export const buildReadModelFromEntityPrompt = ({ eventId, workflow, svgGraph, svgLanes, cardTypes, entity }) => {
  const messages = []

  messages.push(createSystemMessage(systemMessages.EVENT_MODELING_DDD_EXPERT))

  const promptSections = []

  const { workflow: currentDiagram } = workflow.eventsJson?.length
    ? diagramToJson(eventId, workflow, svgGraph, svgLanes)
    : { workflow: [], currentStep: undefined }
  const workflowBackgroundSections = getWorkflowBackgroundSections(workflow, currentDiagram, cardTypes)

  const { name: entityName, dataFields } = entity

  const entityFields = dataFields.map(({ name, exampleData }) => ({ name, exampleData }))

  promptSections.push(...workflowBackgroundSections)

  promptSections.push({
    title: 'Entity definition (data fields)',
    contentType: 'codeblock',
    language: 'json',
    content: JSON.stringify(entityFields)
  })

  promptSections.push({
    title: 'Request',
    content: `
      Generate a Read Model for the actor about to act on "${entityName}". In most of the cases the generated
      data fields should match with the data fields of the entity excluding the id (include it if necessary).
      An attribute can be a primitive or a reference to a non-primitive type like an associated entity.
      An attribute or field name must each be at most 30 characters long.
    `
  })

  const readModelExample = { readModel: examples.readModelExampleOrder }

  promptSections.push({
    title: 'Formatting',
    flattenLines: false,
    content: getJsonOutputFormatting('readModel', JSON.stringify(readModelExample))
  })

  promptSections.push({
    title: 'Note',
    contentType: 'bullet',
    content: [readModelNotes[0], readModelNotes[1]]
  })

  const userContent = buildPrompt(promptSections)
  messages.push(createUserMessage(userContent))

  return messages
}
